import { createIcon } from '@chakra-ui/react'

export const SwapIcon = createIcon({
  displayName: 'SwapIcon',
  path: (
    <>
      <path
        d='M2.5 13.2502L5.83333 16.5835L5.83333 14.0835L11.6667 14.0835L11.6667 12.4168L5.83333 12.4168L5.83333 9.91683L2.5 13.2502ZM14.1667 11.5835L17.5 8.25016L14.1667 4.91683L14.1667 7.41683L8.33333 7.41683L8.33333 9.08349L14.1667 9.0835L14.1667 11.5835Z'
        fill='currentColor'
      />
    </>
  ),
  viewBox: '0 0 20 21',
})
